// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"GY-z","subtitle":"HY-z","wrapper":"IY-z","leftArrow":"JY-z","rightArrow":"KY-z"};